<script setup lang="ts">
import type { PropType } from 'vue'

const props = defineProps({
  status: {
    type: String as PropType<'loading' | 'empty' | 'noMore'>,
    default: 'empty',
  },
  size: {
    type: Number,
    default: 100,
  },
  // 可选：加载时的文字
  loadingText: {
    type: String,
    default: '加载中...',
  },
  // 可选：没有更多数据时的描述
  noMoreText: {
    type: String,
    default: '——— 没有更多数据啦 ———',
  },
  // 最小高度用于占位（可选）
  minHeight: {
    type: [Number, String] as PropType<number | string>,
    default: 120,
  },
})

const isLoading = computed(() => props.status === 'loading')
const isEmpty = computed(() => props.status === 'empty')
const isNoMore = computed(() => props.status === 'noMore')
</script>

<template>
  <!-- v-loading 使用 Element Plus 的 Loading 指令作为“el-loading”效果 -->
  <div
    class="list-placeholder"
    v-loading="isLoading"
    :element-loading-text="loadingText"
    :style="{ minHeight: typeof minHeight === 'number' ? minHeight + 'px' : minHeight }"
  >
    <!-- 允许用户通过 slot 覆盖三种状态的显示（优先级：slot > 内置） -->
    <slot name="loading" v-if="isLoading" />

    <template v-if="!isLoading">
      <!-- empty 状态（可插slot覆盖） -->
      <slot name="empty" v-if="isEmpty">
        <el-empty :image-size="size" />
      </slot>

      <!-- noMore 状态（可插slot覆盖） -->
      <slot name="noMore" v-else-if="isNoMore">
        <el-empty :image-size="1" :description="noMoreText" />
      </slot>
    </template>
  </div>
</template>

<style scoped>
.list-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  /* 视需要可调整内边距/背景 */
  padding: 12px;
}
</style>
